import ApplicationLogo from '@/components/HbkLogo';
import { cn } from '@/lib/utils';
import { Link } from '@inertiajs/react';
import { PropsWithChildren } from 'react';
import BaseLayout from './base-layout';

type GuestLayoutProps = PropsWithChildren<{
    compact?: boolean;
}>;

export default function Guest({ children, compact = false }: GuestLayoutProps) {
    return (
        <BaseLayout>
            <div className={cn(
                'flex min-h-svh flex-col items-center bg-zinc-100',
                compact ? 'justify-start pt-4 sm:pt-6' : 'justify-center pt-6 sm:pt-0'
            )}>
                <div>
                    <Link href="/">
                        <ApplicationLogo className={cn(
                            'fill-current text-gray-500',
                            compact ? 'h-12 sm:h-14' : 'h-14'
                        )} />
                    </Link>
                </div>
                <div className={cn(
                    'w-full px-4',
                    compact ? 'mt-5 sm:mt-6' : 'mt-8'
                )}>
                    {children}
                </div>
            </div>
        </BaseLayout>
    );
}
